module.exports = __webpack_public_path__ + "img/new16.be95f76a.png";